<template>
	<v-stepper app v-model="e1">
		<v-stepper-header>
			<v-stepper-step :complete="e1 > 1" step="1">Create User</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step :complete="e1 > 2" step="2">Create Company</v-stepper-step>

			<v-divider></v-divider>

			<v-stepper-step step="3">Choose Plan</v-stepper-step>
		</v-stepper-header>

		<v-stepper-items>
			<v-stepper-content step="1">
				<v-card
				class=""
				color=""
				height=""
				>
				<v-card-title primary-title>
					Sign Up
				</v-card-title>
				<SignUp />
			</v-card>
		</v-stepper-content>

		<v-stepper-content step="2">
			<v-card
			class=""
			color=""
			height=""
			>
			<v-card-title primary-title>
				Company Info
			</v-card-title>
			<SignUpCompany />
		</v-card>
	</v-stepper-content>

	<v-stepper-content step="3">
		<v-card
		class=""
		color=""
		height=""
		>
		<v-card-title primary-title>
			Choose A Plan
		</v-card-title>
			<Payment />
		</v-card>
        </v-stepper-content>
    </v-stepper-items>
</v-stepper>
</template>

<script>
import SignUp from '../components/SignUp'
import SignUpCompany from '../components/SignUpCompany'
import Payment from './Payment'
export default {
	name: 'register',
	components: {
		SignUp,
		SignUpCompany,
		Payment
	},
	data(){
		return {
		}
	},
	computed: {
		user(){
			return this.$store.getters.user
		},
		e1:{
			set(e1){
				
			},
			get(){
				return this.$store.state.e1
			}
		}
	},
	methods: {

	},
	watch: {
		
	}
}
</script>
